<template>
	<div class="row">
		<div class="col-xl-12">
			<div class="card">
				<div class="card-body">
					<h5>
						<i class="fas fa-address-card" aria-hidden="true"></i>
						Cursos asociados al alumno.
					</h5>
					<b-form-select
						v-model="seleccionado"
						:options="optionsCurso"
						@change="valueCurso($event)"
					></b-form-select>
					<small
						>A continuación, podrás ver el listado de evaluaciones rendidas por
						el alumno.</small
					>
				</div>
			</div>
		</div>
		<div v-if="banderaEvaluacion" class="col-xl-8">
			<div class="card">
				<div class="card-body">
					<h5>Listado evaluaciones.</h5>
					<small
						>A continuación podras ver el listado de evaluaciones del
						alumno.</small
					>
					<b-table
						:items="evaluaciones"
						:columns="columns"
						class="mt-3"
						striped
						hover
						outlined
					></b-table>
					<PuSkeleton v-if="skeletonSelect" :count="5"></PuSkeleton>
					<b-alert :show="booleanCurso" variant="warning">
						No existen evaluaciones rendidas por este alumno.
					</b-alert>
				</div>
			</div>
		</div>
		<div v-if="banderaEvaluacion" class="col-xl-4">
			<div class="card">
				<div class="card-body">
					<h5>Estado actual del curso</h5>
					<small>Selecciona el estado que deseas cambiar.</small>
					<b-form-select
						:value="selectEstado"
						:options="optionsEstado"
						@change="cambioEstado($event)"
					></b-form-select>
				</div>
			</div>
			<!-- 		<div class="card">
				<div class="card-body">
					<h5>Rol actual</h5>
					<small>Selecciona el rol que deseas cambiar.</small>
					<b-form-select
						:value="selectRol"
						:options="optionsRol"
						@change="cambioRol($event)"
					></b-form-select>
				</div>
			</div> -->
			<div class="card">
				<div class="card-body">
					<h5>Acciones</h5>
					<b-alert show variant="warning"
						>Recuerda que todos los accesos a cursos son con un súper
						usuario.</b-alert
					>
					<table class="table">
						<thead>
							<tr>
								<th scope="col">Nombre Curso</th>
								<th scope="col">Accion</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ infoCurso.tituloCurso }}</td>
								<td>
									<a href="javascript:void(0)" @click="suplantacion()">
										<i class="fas fa-magic" aria-hidden="true"></i
									></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<toastComponent ref="toastComponent"></toastComponent>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toastComponent from "@/components/toastComponent";
export default {
	components: {
		toastComponent
	},
	data() {
		return {
			banderaEvaluacion: false,
			msgEvaluaciones: "",
			infoCurso: "",
			seleccionado: null,
			columns: [
				"tipo",
				"nombre_modulo",
				"nombre_evaluacion",
				"ponderacion",
				"nota_final"
			],
			skeletonSelect: false,
			evaluaciones: [],
			selectEstado: null,
			optionsEstado: [
				{ value: null, text: "Elige una opción" },
				{ value: 0, text: "Eliminado" },
				{ value: 1, text: "Habilitado" },
				{ value: 2, text: "Finalizado" },
				{ value: 3, text: "Habilitado sin evaluaciones" },
				{ value: 4, text: "Habilitado sin fecha" }
			],
			selectRol: null,
			optionsRol: [
				{ value: null, text: "Elige una opción" },
				{ value: 1, text: "Alumno" },
				{ value: 2, text: "Profesor" },
				{ value: 3, text: "Coordinadora" }
			],
			dataAlumnoCurso: null,
			booleanCurso: null
		};
	},
	computed: {
		...mapState(["accessToken"]),
		...mapState("alumno", ["jsonCursoAlumno"]),
		...mapState("alumno", ["jsonAlumno"]),
		optionsCurso() {
			let cursoAlumnos = [{ value: null, text: "Selecciona una opción" }];
			const x = this.jsonCursoAlumno.map(al =>
				cursoAlumnos.push({
					value: al.idCurso,
					text: "#" + al.idCurso + " | " + al.tituloCurso
				})
			);
			return cursoAlumnos;
		}
	},
	methods: {
		...mapActions("alumno", ["updateEvaluacionJson"]),
		valueCurso(event) {
			this.booleanCurso = false;
			this.msgEvaluaciones = "";
			this.banderaEvaluacion = true;
			this.evaluaciones = [];
			this.skeletonSelect = true;
			this.getEvaluaciones(event);
			this.getAlumnoCurso(event);

			const selecionCurso = this.jsonCursoAlumno.find(
				cursoAl => cursoAl.idCurso === event
			);
			this.infoCurso = {
				idCurso: selecionCurso.idCurso,
				tituloCurso: selecionCurso.tituloCurso
			};
		},
		suplantacion() {
			let form = {
				idCurso: this.infoCurso.idCurso,
				idAlumno: this.jsonAlumno.idAlumno,
				token: this.accessToken
			};

			this.axios
				.post("api/loginSuplentacion", form)
				.then(response => {
					if (response.data.msg == "exito") {
						window.open(response.data.url, "_blank");
					}
				})
				.catch(error => {});
		},
		cambioRol(event) {
			let form = {
				rolAlumno: event
			};

			this.axios
				.put("api/updateEstadoRol/" + this.dataAlumnoCurso.idAlumnoxCurso, form)
				.then(res => {
					let estado = res.data.estado;
					if (estado == "rolActualizado") {
						let arrayToast = {
							msg: res.data.msg,
							title: "Exito",
							variant: "success"
						};
						this.$refs.toastComponent.makeToast(arrayToast);
					}
				})
				.catch(err => console.log(err));
		},
		async cambioEstado(event) {
			const form = {
				estadoAlumno: event
			};

			const { data } = await this.axios.put(
				"api/updateEstadoAlumno/" + this.dataAlumnoCurso.idAlumnoxCurso,
				form
			);
			const { estado, msg } = data;

			if (estado == "estadoActualizado") {
				let arrayToast = {
					msg: msg,
					title: "Exito",
					variant: "success"
				};
				this.$refs.toastComponent.makeToast(arrayToast);
			}
		},
		async getAlumnoCurso(idCurso) {
			const { data } = await this.axios.get(
				"api/getAlumnoCurso/" + idCurso + "/" + this.jsonAlumno.idAlumno
			);
			const { getAlumno } = data;
			this.dataAlumnoCurso = getAlumno;
			if (this.dataAlumnoCurso) {
				this.selectEstado = this.dataAlumnoCurso.estadoCurso;
				this.selectRol = this.dataAlumnoCurso.rol;
			}
		},
		async getEvaluaciones(idCurso) {
			const { data } = await this.axios.get(
				"api/infoCursoAlumno/" + idCurso + "/" + this.jsonAlumno.idAlumno
			);
			const {
				getEvaluacionesControl: controles,
				getEvaluacionesExamen: examenes,
				getEvaluacionDiagnostico: diagnosticos,
				getEvaluacionRecuperativa: recuperativas
			} = data;

			const control = controles.map(elem => ({
				tipo: "Control",
				nombre_modulo: elem.idModulo,
				nombre_evaluacion: elem.nombreEvaluacion,
				ponderacion: elem.ponderacion,
				nota_final: elem.nota
			}));

			const examen = examenes.map((elem, key) => ({
				tipo: "Examen",
				nombre_modulo: elem.idModulo,
				nombre_evaluacion: elem.nombreEvaluacion,
				ponderacion: elem.ponderacion,
				nota_final: elem.nota
			}));

			const diagnostico = diagnosticos.map((elem, key) => ({
				tipo: "Diagnostico",
				nombre_modulo: elem.idModulo,
				nombre_evaluacion: elem.nombreEvaluacion,
				ponderacion: elem.ponderacion,
				nota_final: elem.nota
			}));

			const recuperativa = recuperativas.map((elem, key) => ({
				tipo: "Recuperativa",
				nombre_modulo: elem.idModulo,
				nombre_evaluacion: elem.nombreEvaluacion,
				ponderacion: elem.ponderacion,
				nota_final: elem.nota
			}));

			this.evaluaciones = [].concat(control, examen, diagnostico, recuperativa);

			if (this.evaluaciones == 0) {
				this.booleanCurso = true;
			}

			this.skeletonSelect = false;
		}
	}
};
</script>
